"use strict";

import { Swiper, Navigation } from "swiper";
import breakpoints from "../helpers/breakpoints";
import gtm from "../gtm";

const initializeProductsCarousel = () => {
    if (!window.productsCarouselInitialized) {
        const carousels = $(".products-carousel-glide");

        const { xs, sm, md, lg, xl, xxl } = breakpoints;

        carousels.each((index, carousel) => {
            const selector        = "." + $(carousel).data().id + " .swiper";
            const prevButton      = `${selector} .btn-arrow-left`;
            const nextButton      = `${selector} .btn-arrow-right`;
            var eventWasTriggered = false;

            new Swiper(selector, {
                loop: false,
                modules: [Navigation],
                parallax: true,
                simulateTouch: false,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                    disabledClass: "disabled"
                },
                breakpoints: {
                    [xs]: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    [sm]: {
                        slidesPerView: 1.3,
                        spaceBetween: 20,
                    },
                    [md]: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                    [lg]: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                    },
                    [xl]: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                    },
                    [xxl]: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                    }
                },
            });

            // Function to check the first slide
            const checkFirstSlide = () => {
                $(carousel).find(".swiper-slide").each(function (index, slide) {

                    if ($(slide).length && $(slide).is(":empty")) {
                        $(slide).remove();
                    }
                });
            };

            checkFirstSlide();

            $(window).on("scroll", function () {
                if (!eventWasTriggered && $(carousel).find(".js-offer-tile").length) {
                    var windowHeight  = $(window).height();
                    var scrollTop     = $(window).scrollTop();
                    var elementOffset = $(carousel).offset().top;

                    if (scrollTop + windowHeight > elementOffset) {
                        // Run tracking function when the element is on the screen
                        gtm.viewItemListEvent($(carousel));
                        eventWasTriggered = true;
                    }
                }
            });
        });

        window.productsCarouselInitialized = true;
    }
};

export default initializeProductsCarousel;
